import { create } from "zustand";

interface IAuthStore {
  authState: string;
  user: any | null;
  isCheckingAuth: boolean;
  setAuthState: (authState: string) => void;
  setUser: (user: any | null) => void;
  setIsCheckingAuth: (isCheckingAuth: boolean) => void;
}

export const useAuthStore = create<IAuthStore>()((set) => ({
  authState: "signin",
  user: null,
  isCheckingAuth: true, // Start as true to prevent flash
  setAuthState: (authState) => set(() => ({ authState })),
  setUser: (user) => set(() => ({ user })),
  setIsCheckingAuth: (isCheckingAuth) => set(() => ({ isCheckingAuth })),
}));
